import { useState } from 'react'

import { useApolloClient } from '@apollo/client'
import { Box, Button } from '@factorialco/deprecated-design-system'
import { SoftwarePaymentsDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  InvoiceFragment,
  SoftwareManagementExchangeCurrencyFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import CreatePaymentModal from '../CreatePaymentModal'
import InvoiceDetail from '../InvoiceDetail'

interface Props {
  softwareSetupId: number
  currencies: SoftwareManagementExchangeCurrencyFragment[]
}

const AddSoftwarePaymentButton = ({ softwareSetupId, currencies }: Props) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [invoice, setInvoice] = useState<InvoiceFragment | null>(null)
  const [showInvoiceDetail, setShowInvoiceDetail] = useState<boolean>(false)
  const apolloClient = useApolloClient()

  const showModal = () => setModalOpen(true)
  const hideModal = () => setModalOpen(false)

  const handleInvoiceUpload = (invoiceParam: InvoiceFragment) => {
    hideModal()
    setInvoice(invoiceParam)
    setShowInvoiceDetail(true)
  }

  const hideInvoiceDetail = () => {
    setShowInvoiceDetail(false)
  }

  const updateDataTable = () => {
    apolloClient.refetchQueries({
      include: [SoftwarePaymentsDataTableDocument],
    })
  }

  return (
    <>
      <Box>
        <Button type="secondary" onClick={showModal} iconName="add">
          {i18n.t('software_management.software_setups.payments_widget.cta')}
        </Button>
      </Box>

      {modalOpen && (
        <CreatePaymentModal
          softwareSetupId={softwareSetupId}
          onSuccess={() => {
            updateDataTable()
            hideModal()
          }}
          onClose={hideModal}
          currencies={currencies}
          onUploadInvoice={handleInvoiceUpload}
        />
      )}
      {invoice && showInvoiceDetail && (
        <InvoiceDetail
          invoiceId={invoice.id}
          onClose={() => {
            hideInvoiceDetail()
            updateDataTable()
          }}
        />
      )}
    </>
  )
}

export default AddSoftwarePaymentButton
